module.exports = {
  latestClaimsDate: new Date('2023-12-31'),
};
